// University of Delaware's undergraduate majors (#2748). Read on 2026-10-01.
// UD's catalog (catalog.udel.edu) answered every request with a bot
// challenge, so the list comes from UD's own program pages instead:
//  - College of Arts and Sciences: its Undergraduate Programs page, which
//    names each major with its degree (BA, BS, BFA, BM). A major offered as
//    "BA or BS" is listed once per degree. The associate degree is left out.
//  - Lerner College of Business and Economics: its Undergraduate Programs
//    page, degrees as written there (B.S., B.A.); the undeclared business
//    entry is left out. Names keep Lerner's sentence case.
//  - Every other college: UD Admissions' Major Finder, keeping the entries
//    it tags as bachelor's programs, under the college it names. The Major
//    Finder gives no degree type, so the degree is null. Associate programs,
//    Engineering Undeclared and University Studies (UD's undeclared start)
//    are left out.
// The KB's majors list was the starting point; the school's pages win.
const majors = {
    "slug": "university-of-delaware",
    "read": "2026-10-01",
    "intro": "Every bachelor's major UD lists on its college and admissions program pages, grouped by the college that offers it, with the degree where the page names one. Minors, certificates, associate degrees and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "UD College of Arts and Sciences, Undergraduate Programs",
                "url": "https://www.udel.edu/academics/colleges/cas/prospective-students/undergraduate-programs/"
            },
            "majors": [
                {
                    "name": "Actuarial Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "Ancient Greek and Roman Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology Education",
                    "degree": "BA"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Applied Music",
                    "degree": "BM"
                },
                {
                    "name": "Applied Physics",
                    "degree": "BS"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art Conservation",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Art History/Language Studies",
                    "degree": "BA"
                },
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Astronomy",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences Education",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry Education",
                    "degree": "BA"
                },
                {
                    "name": "Chinese Education",
                    "degree": "BA"
                },
                {
                    "name": "Chinese Studies",
                    "degree": "BA"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BS"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Literature",
                    "degree": "BA"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "English Education",
                    "degree": "BA"
                },
                {
                    "name": "European Studies",
                    "degree": "BA"
                },
                {
                    "name": "Fashion Design and Product Innovation",
                    "degree": "BS"
                },
                {
                    "name": "Fashion Merchandising and Management",
                    "degree": "BS"
                },
                {
                    "name": "Fine Arts",
                    "degree": "BFA"
                },
                {
                    "name": "French Education",
                    "degree": "BA"
                },
                {
                    "name": "French Studies",
                    "degree": "BA"
                },
                {
                    "name": "Game Studies and Esports",
                    "degree": "BA"
                },
                {
                    "name": "German Education",
                    "degree": "BA"
                },
                {
                    "name": "German Studies",
                    "degree": "BA"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History (Social Studies) Education",
                    "degree": "BA"
                },
                {
                    "name": "International Relations",
                    "degree": "BA"
                },
                {
                    "name": "Italian Education",
                    "degree": "BA"
                },
                {
                    "name": "Italian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Japanese Studies",
                    "degree": "BA"
                },
                {
                    "name": "Jazz and Improvisation",
                    "degree": "BM"
                },
                {
                    "name": "Latin American & Iberian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latin Education",
                    "degree": "BA"
                },
                {
                    "name": "Liberal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics Education",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics Education",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Economics",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music Composition",
                    "degree": "BM"
                },
                {
                    "name": "Music Education",
                    "degree": "BM"
                },
                {
                    "name": "Music History and Literature",
                    "degree": "BM"
                },
                {
                    "name": "Music Theory",
                    "degree": "BM"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physics Education",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Political Science Education",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology Education",
                    "degree": "BA"
                },
                {
                    "name": "Russian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Sociology Education",
                    "degree": "BA"
                },
                {
                    "name": "Spanish Education",
                    "degree": "BA"
                },
                {
                    "name": "Spanish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Theatre Studies",
                    "degree": "BA"
                },
                {
                    "name": "Three Languages",
                    "degree": "BA"
                },
                {
                    "name": "Visual Communications",
                    "degree": "BFA"
                },
                {
                    "name": "Women and Gender Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Alfred Lerner College of Business and Economics",
            "source": {
                "label": "UD Lerner College, Undergraduate Programs",
                "url": "https://lerner.udel.edu/programs/undergraduate-programs/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S."
                },
                {
                    "name": "Business analytics",
                    "degree": "B.S."
                },
                {
                    "name": "Computer science and business",
                    "degree": "B.S.",
                    "note": "Listed by Lerner as an honors program"
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Economics education",
                    "degree": "B.A."
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "B.S."
                },
                {
                    "name": "Finance",
                    "degree": "B.S."
                },
                {
                    "name": "Financial planning and wealth management",
                    "degree": "B.S."
                },
                {
                    "name": "Fintech",
                    "degree": "B.S."
                },
                {
                    "name": "Global business",
                    "degree": "B.S."
                },
                {
                    "name": "Hospitality and event business management",
                    "degree": "B.S."
                },
                {
                    "name": "Hospitality industry management",
                    "degree": "B.S."
                },
                {
                    "name": "Human Resource Management",
                    "degree": "B.S."
                },
                {
                    "name": "Management",
                    "degree": "B.S."
                },
                {
                    "name": "Management information systems",
                    "degree": "B.S."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S."
                },
                {
                    "name": "Operations management",
                    "degree": "B.S."
                },
                {
                    "name": "Sport management",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Agriculture and Natural Resources",
            "source": {
                "label": "UD Undergraduate Admissions, Major Finder",
                "url": "https://www.udel.edu/apply/undergraduate-admissions/major-finder/"
            },
            "majors": [
                {
                    "name": "Agriculture and Natural Resources",
                    "degree": null
                },
                {
                    "name": "Animal Biosciences",
                    "degree": null
                },
                {
                    "name": "Animal Science",
                    "degree": null
                },
                {
                    "name": "Environmental and Resource Economics",
                    "degree": null
                },
                {
                    "name": "Food Science",
                    "degree": null
                },
                {
                    "name": "Food and Agribusiness Marketing",
                    "degree": null
                },
                {
                    "name": "Insect Ecology and Conservation",
                    "degree": null
                },
                {
                    "name": "Landscape Architecture",
                    "degree": null
                },
                {
                    "name": "Plant Science",
                    "degree": null
                },
                {
                    "name": "Pre-Veterinary Medicine",
                    "degree": null
                },
                {
                    "name": "Sports Performance Analytics",
                    "degree": null
                },
                {
                    "name": "Statistics",
                    "degree": null
                },
                {
                    "name": "Sustainable Food Systems",
                    "degree": null
                },
                {
                    "name": "Wildlife Ecology and Conservation",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Earth, Ocean, and Environment",
            "source": {
                "label": "UD Undergraduate Admissions, Major Finder",
                "url": "https://www.udel.edu/apply/undergraduate-admissions/major-finder/"
            },
            "majors": [
                {
                    "name": "Earth Science Education",
                    "degree": null
                },
                {
                    "name": "Earth Sciences",
                    "degree": null
                },
                {
                    "name": "Environmental Science",
                    "degree": null
                },
                {
                    "name": "Environmental Studies",
                    "degree": null
                },
                {
                    "name": "GIScience and Environmental Data Analytics",
                    "degree": null
                },
                {
                    "name": "Geography",
                    "degree": null
                },
                {
                    "name": "Geography Education",
                    "degree": null
                },
                {
                    "name": "Marine Science",
                    "degree": null
                },
                {
                    "name": "Meteorology and Climate Science",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Education and Human Development",
            "source": {
                "label": "UD Undergraduate Admissions, Major Finder",
                "url": "https://www.udel.edu/apply/undergraduate-admissions/major-finder/"
            },
            "majors": [
                {
                    "name": "Early Childhood Education/Early Childhood Special Education",
                    "degree": null
                },
                {
                    "name": "Elementary and Middle School Teacher Education",
                    "degree": null
                },
                {
                    "name": "Human Relations Administration",
                    "degree": null
                },
                {
                    "name": "Human Services",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "UD Undergraduate Admissions, Major Finder",
                "url": "https://www.udel.edu/apply/undergraduate-admissions/major-finder/"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence Engineering",
                    "degree": null
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": null
                },
                {
                    "name": "Chemical Engineering",
                    "degree": null
                },
                {
                    "name": "Civil Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Construction Engineering and Management",
                    "degree": null
                },
                {
                    "name": "Cybersecurity Engineering",
                    "degree": null
                },
                {
                    "name": "Electrical Engineering",
                    "degree": null
                },
                {
                    "name": "Environmental Engineering",
                    "degree": null
                },
                {
                    "name": "Information Systems",
                    "degree": null
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": null
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Health Sciences",
            "source": {
                "label": "UD Undergraduate Admissions, Major Finder",
                "url": "https://www.udel.edu/apply/undergraduate-admissions/major-finder/"
            },
            "majors": [
                {
                    "name": "Applied Molecular Biology and Biotechnology",
                    "degree": null
                },
                {
                    "name": "Health Behavior Science",
                    "degree": null
                },
                {
                    "name": "Human Physiology",
                    "degree": null
                },
                {
                    "name": "Integrated Health Sciences",
                    "degree": null
                },
                {
                    "name": "Kinesiology",
                    "degree": null
                },
                {
                    "name": "Medical Diagnostics",
                    "degree": null
                },
                {
                    "name": "Medical Diagnostics-Pre Physician Assistant",
                    "degree": null
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": null
                },
                {
                    "name": "Nursing",
                    "degree": null
                },
                {
                    "name": "Nutrition and Dietetics",
                    "degree": null
                },
                {
                    "name": "Nutrition and Medical Sciences",
                    "degree": null
                },
                {
                    "name": "Public Health",
                    "degree": null
                },
                {
                    "name": "Sports Health",
                    "degree": null
                }
            ]
        },
        {
            "name": "Joseph R. Biden, Jr. School of Public Policy and Administration",
            "source": {
                "label": "UD Undergraduate Admissions, Major Finder",
                "url": "https://www.udel.edu/apply/undergraduate-admissions/major-finder/"
            },
            "majors": [
                {
                    "name": "Civic Leadership and Policy Studies",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
